import { Holiday } from '@/types/admin-holiday';
import { convertWarekiDetail } from '@/utils/wareki';
import { Empty, TableProps } from 'antd';
import { SorterResult } from 'antd/es/table/interface';
import { AppTable } from '../atoms';
import { EMPTY_TEXT_FILTERED } from '@/constants';

interface HolidayTableProps {
  data: Holiday[];
  sortInfo?: {
    columnKey?: string;
    order?: 'ascend' | 'descend';
  };
  onTableChange?: (sorter: SorterResult<Holiday> | SorterResult<Holiday>[]) => void;
  isLoading?: boolean;
}

const formatWarekiDate = (dateStr: string | null): string => {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-').map(Number);
  if (!y || !m || !d) return '';
  const era = convertWarekiDetail(y, m, d);
  if (!era) return '';
  return `${era}年${String(m).padStart(2, '0')}月${String(d).padStart(2, '0')}日`;
};

const HolidayTable = ({ data, sortInfo, onTableChange, isLoading }: HolidayTableProps) => {
  const columns: TableProps<Holiday>['columns'] = [
    {
      title: 'ID',
      dataIndex: 'no',
      key: 'no',
      width: '10%',
    },
    {
      title: '休日名',
      dataIndex: 'holiday_name',
      key: 'holiday_name',
      width: '40%',
    },
    {
      title: '開始日',
      dataIndex: 'start_date',
      key: 'start_date',
      sorter: true,
      sortOrder: sortInfo?.columnKey === 'start_date' ? sortInfo.order : undefined,
      render: (value: string) => formatWarekiDate(value),
      width: '25%',
    },
    {
      title: '終了日',
      dataIndex: 'end_date',
      key: 'end_date',
      sorter: true,
      sortOrder: sortInfo?.columnKey === 'end_date' ? sortInfo.order : undefined,
      render: (value: string) => formatWarekiDate(value),
      width: '25%',
    },
  ];

  return (
    <AppTable
      columns={columns}
      dataSource={data}
      rowKey={record => `${record.start_date}-${record.holiday_name}`}
      onChange={(_pagination, _filters, sorter) =>
        onTableChange?.(sorter as SorterResult<Holiday> | SorterResult<Holiday>[])
      }
      loading={isLoading}
      locale={{
        emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={EMPTY_TEXT_FILTERED} />,
      }}
      isAdminSite
    />
  );
};

export default HolidayTable;
